module.exports = __webpack_public_path__ + "img/thuisbezorgd.0084d5bd.png";